export const SET_COLLECTION = "SET_COLLECTION";
export const SET_TOP_NFT = "SET_TOP_NFT";
export const SET_TOP_MINT = "SET_TOP_MINT";
export const SET_NEW_COLLECTION = "SET_NEW_COLLECTION";

//Filters
export const GET_TIME_FRAMES = "GET_TIME_FRAMES";
export const SET_FILTER = "SET_FILTER";
